import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  .footer {
    &__fqa {
      li {
        &:not(.footer__fqa-more) {
          font: ${font('default', 'normal', '14px/1.5')};
          padding-bottom: 10px;
          margin-bottom: 10px;
          border-bottom: 1px solid;
        }
      }

      &-more {
        margin-top: 22px;

        a {
          text-decoration: underline;
        }
      }
    }
  }
`
